// @ts-nocheck
/* eslint-disable */
export const gradingIcon = {
    data: `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2.66663 4.66667H13.3333V6H2.66663V4.66667ZM2.66663 8.66667H13.3333V7.33333H2.66663V8.66667ZM2.66663 11.3333H7.33329V10H2.66663V11.3333ZM2.66663 14H7.33329V12.6667H2.66663V14ZM10.2733 12.1133L9.33329 11.1667L8.39329 12.1067L10.2733 14L13.3333 10.9467L12.3866 10L10.2733 12.1133ZM2.66663 2V3.33333H13.3333V2H2.66663Z" fill="currentColor"/></svg>`,
    name: 'grading' as const
};